<mat-form-field *ngIf="control" class="app-datepicker">
  <mat-label>{{ label }}</mat-label>

  <input
    matInput
    [matDatepicker]="dp"
    [formControl]="control"
    [required]="required"
    [min]="minDate"
    [max]="maxDate"
    [placeholder]="placeholder"
    autocomplete="off"
    [readonly]="readonly">

  <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>

  <mat-datepicker
    #dp
    startView="multi-year"
    [disabled]="disabledDatePicker"
    (yearSelected)="chosenYearHandler($event)"
    (monthSelected)="chosenMonthHandler($event, dp)">
  </mat-datepicker>

  <mat-error *ngIf="control.hasError('required')">
    To pole jest wymagane
  </mat-error>

  <mat-error *ngIf="control.hasError('matDatepickerMin')">
    Najwcześniejszy dostępny miesiąc:
    {{ minSalesMonthLabel }}
  </mat-error>

  <mat-error *ngIf="control.hasError('matDatepickerMax')">
    Najpóźniejszy dostępny miesiąc:
    {{ maxSalesMonthLabel }}
  </mat-error>

  <mat-error *ngIf="control.hasError('backendError')">
    {{ control.getError('backendError') }}
  </mat-error>

  <mat-hint *ngIf="minSalesMonthLabel">
    Najwcześniejszy dostępny miesiąc:
    {{ minSalesMonthLabel }}
  </mat-hint>

  <mat-hint *ngIf="!minSalesMonthLabel && maxSalesMonthLabel">
    Najpóźniejszy dostępny miesiąc:
    {{ maxSalesMonthLabel }}
  </mat-hint>
</mat-form-field>
